import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from './Spinner';

const Loading = ({ NoFullScreen }) => {
  const style = {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '100px',
    paddingBottom: '25px',
    paddingTop: '50px',
  };

  const styleFullScreen = {
    bottom: 0,
    left: 0,
    marginBottom: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 'auto',
    maxHeight: '100px',
    maxWidth: '100px',
    position: 'fixed',
    right: 0,
    top: 0,
  };
  return (
    <div
      style={NoFullScreen ? style : styleFullScreen}
      data-testid="loading"
    >
      <Spinner />
    </div>
  );
};

Loading.defaultProps = {
  NoFullScreen: false,
};

Loading.propTypes = {
  NoFullScreen: PropTypes.bool,
};

export default Loading;
